import * as React from "react";
import { UnfinishedReason, unfinishedReasonLabels } from "../../domain/result";
import { useTranslation } from "../../utils/i18n/lang";

interface Props {
    reason: UnfinishedReason;
}

export const UnfinishedReasonView = (p: Props) => {
    const t = useTranslation(unfinishedReasonLabels);
    return <span>{t[p.reason]}</span>;
};
